export default {
  install(Vue, options) {
    Vue.prototype.LS = {
      set(key, value) {
        return window.localStorage.setItem(key, value)
      },
      get(key) {
        return window.localStorage.getItem(key)
      },
      remove(key) {
        return window.localStorage.removeItem(key)
      },
      clear() {
        return window.localStorage.clear()
      },
    }
    // 页面跳转
    Vue.prototype.routerChange = function(name, query, params) {
      this.$router.push({ name: name, query: query, params: params })
    }

    // 显示数据标签
    Vue.prototype.showLabel = function(label, list, key) {
      let result = ''
      if (!list || !list.length) {
        return result
      }
      for (let i = 0, il = list.length; i < il; i++) {
        let item = list[i]
        if (label === item[key || 'id']) {
          result = item.name || item.label
          break
        }
      }
      return result
    }

    // 处理返回的错误信息
    Vue.prototype.executeError = function(error) {
      if (error && error.m) {
        // 提取错误对象中的信息
        return error.m
      } else if (error && error.response) {
        return error.response.status + ' : ' + error.response.statusText
      } else {
        console.error(error)
      }
    }

    // 保留两位小数
    Vue.prototype.round2 = function(number) {
      return Number(number).toFixed(2)
    }
  },
}
